import React from "react";
import StoreHome from "./home";
const StoreBookoutItemsIndex = React.lazy(() => import("../bookout_items/web/"));
import StoreOverallsRoutes from "modules/store/overalls/web/routes"
import StoreOverallsGarmentsRoutes from "modules/store/overalls/garments/web/routes"
import StoreOverallsStatusesRoutes from "modules/store/overalls/statuses/web/routes"

let routes = [];
routes.push({ path: "/store/bookout_items", component: StoreBookoutItemsIndex, name: "StoreBookoutItems" });
routes = _.concat(routes, StoreOverallsStatusesRoutes)
routes = _.concat(routes, StoreOverallsGarmentsRoutes)
routes = _.concat(routes, StoreOverallsRoutes);


routes.push({
  path: "/store",
  component: StoreHome,
  name: "Store Home",
});


export default routes;
